const LOOP_APP_LINK_HOSTS = new Set(["loopreservas.com", "www.loopreservas.com"]);

export function repairLegacyRatingLink(pathname, search = "") {
  const prefix = "/calificar-serviciosbusinessId=";
  if (!pathname.startsWith(prefix)) return "";
  const query = pathname.slice("/calificar-servicios".length);
  return `/calificar-servicios?${query}${search ? "&" + search.slice(1) : ""}`;
}

export function buildLoopRouteFromExternalUrl(rawUrl) {
  try {
    const url = new URL(String(rawUrl || ""));
    const protocol = String(url.protocol || "").replace(":", "").toLowerCase();
    const host = String(url.hostname || "").toLowerCase();
    const path = url.pathname || "/";
    const search = url.search || "";
    const hash = url.hash || "";

    if ((protocol === "https" || protocol === "http") && LOOP_APP_LINK_HOSTS.has(host)) {
      return (repairLegacyRatingLink(path, search) || `${path}${search}`) + hash;
    }

    if (protocol === "loopreservas") {
      if (host === "worker-invite") return `/worker-invite${search}${hash}`;
      if (path && path.startsWith("/worker-invite")) return `${path}${search}${hash}`;

      // LOOP LOYALTY QR CUSTOM SCHEME V2
      // Supports: loopreservas://loyalty/checkin/:token
      // This lets the temporary loyalty redemption QR open the installed app
      // without requiring Android assetlinks.json to be published during testing.
      if (host === "loyalty") return `/loyalty${path || ""}${search}${hash}`;
      if (path && path.startsWith("/loyalty")) return `${path}${search}${hash}`;

      if (host === "auth") return "";
      if (path && path !== "/") return `${path}${search}${hash}`;
    }
  } catch (_) {}
  return "";
}

